<div class="flex items-center !gap-2">
    <input
        type="checkbox"
        [checked]="isChecked()"
        [disabled]="readonly() || control.disabled"
        (change)="onCheckboxChange($event)"
        class="form-check-input checked:!bg-bold-green"
    />
    <label class="text-sm" [class.font-medium]="labelVariant() === 'primary'">{{ label() | translate }}</label>
</div>
